<template lang="html">
  <div class="guide">
    <Overlay
      :width="width"
      :autoHeight="autoHeight"
      :link="closeLink">
      <div class="guide-content">
        <div>
          <h1 class="guide-heading">{{contentHeading}}</h1>
        </div>

        <div class="two-columns">
          <div class="col">
            <div v-html="content"></div>
            <slot/>
          </div>

          <div class="col" v-if="contentVideo || contentImage">
            <video v-if="contentVideo" class="guide-video" :src="contentVideo" loop muted autoplay playsinline/>
            <LazyImage class="guide-image" v-if="contentImage" :url="contentImage"/>
          </div>
        </div>

        <div class="guide-navigation">
          <div>
            <router-link
              v-if="previousLink"
              :to="previousLink"
              class="btn is-subtle">
              {{backText}}
            </router-link>
          </div>

          <div>
            <router-link
              v-if="nextLink"
              :to="nextLink"
              class="btn is-primary">
              {{buttonText}}
              <Sprite name="arrow"/>
            </router-link>
          </div>
        </div>
      </div>
    </Overlay>
  </div>
</template>

<script>
import Overlay from '@/components/Overlay'
import Sprite from '@/components/Sprite'
import LazyImage from '@/components/LazyImage'

export default {
  name: 'Guide',

  components: {
    Overlay,
    LazyImage,
    Sprite
  },

  props: {
    contentHeading: String,
    contentVideo: String,
    contentImage: String,
    content: String,
    width: {
      type: String,
      default: 'medium'
    },
    buttonText: {
      type: String,
      default: 'Proceed'
    },
    backText: {
      type: String,
      default: 'Go Back'
    },
    closeLink: Object,
    nextLink: Object,
    autoHeight: Boolean,
    previousLink: Object
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.guide-content
  display: flex
  flex-direction: column
  justify-content: space-between
  height: 100%

  video
    max-height: 500px
    top: 0
    width: 100%
    margin: auto
    display: block
    text-align: center

    &:focus
      outline: none

  .two-columns
    align-items: center

    .col
      flex: 1

  .helper-text
    text-align: left

.guide-heading
  border-bottom: 1px solid $color-border
  padding-bottom: $gap-medium
  margin: 0
  font-size: 18px

.guide-navigation
  display: flex
  justify-content: space-between
  border-top: 1px solid $color-border
  padding-top: $gap-medium

  .btn
    &:hover
      .sprite
        opacity: 1

  .sprite
    transition: opacity .2s ease-in-out
    position: relative
    width: 12px
    height: 12px
    top: 2px
    opacity: 0.75
    margin-left: 5px

.guide-video, .guide-image
  display: none
  max-width: 100%
  height: 500px
  border-radius: 10px
  margin: auto

  @include media($media-gt-small)
    display: block

.guide-image
  padding: $gap-x-large
</style>
